import {  Box } from "@chakra-ui/react";

export function Alertbar(){
    return (
        <div>
            <Box m={'auto'} 
            alignItems='center' 
            bgColor={'#5500B0'}
            color={'white'}  
            textAlign='center'
            p={'5px'}
            >
        
            <h1>
                Chargebee's Summer Release helps you monetize effectively <a href="/" style={{color:"#EDAA1E"}}> See what's new </a>
            </h1>
                
            </Box>
        </div>
    )
}